import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { config } from '../../config';

function Metadata(props) {
  const { t } = useTranslation();

  return (
    <Helmet htmlAttributes={{ lang: t('meta.lang') }}>
      <title>{t('meta.title')}</title>
      <meta name="description" content={t('meta.description')}></meta>
      {config.ENV === 'develop' && (
        <meta name="robots" content="noindex"></meta>
      )}
    </Helmet>
  );
}

Metadata.propTypes = {};

export default Metadata;
